import environment from '@/environment';
import { createHeaders } from '@/api/api-utils';
import { ActionData, actionDataSchema } from '@/schemas/actionDataSchema';

export const callAction = async (name: string, args: Record<string, unknown> = {}): Promise<ActionData> => {
  const body = {
    name,
    arguments: args,
  };

  const response: unknown = await fetch(`${environment.serverBaseUrl}/action`, {
    method: 'POST',
    headers: createHeaders(),
    body: JSON.stringify(body),
  }).then((res) => res.json());

  return actionDataSchema.parse(response);
};
